export default __webpack_public_path__ + "static/comment-fd2ac855bafbec779249798c523b277f.jpg";